import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './SwitchUserModal.css';
import ApiService from '../../../services/apiService';
import { clearCart } from '../../../../Redux/actions/cartAction';
import userManagement from '../../../services/userManagement';

const SwitchUserModal = ({ visible, onClose, onVerified, user }) => {
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  useEffect(() => {
    if (visible && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 300);
    }
  }, [visible]);

  const handleSwitchUser = async () => {
    if (password !== user?.passCode) {
      alert('Incorrect Passcode');
      return;
    }

    try {
      const token = localStorage.getItem('Token');
      await localStorage.setItem('Token', user.userToken);
      dispatch(clearCart());

      const apiService = new ApiService();
      const body = {
        userNo: userManagement.getUserId(token),
        userToken: token,
      };
      await apiService.put('LOGIN_EMPLOYEE', body);

      onVerified();
      onClose();
      navigate('/landing');
    } catch (error) {
      console.error('Error setting token:', error);
    }
  };

  if (!visible) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2 className="modal-title">Switch User</h2>
        <p className="modal-subtitle">enter_pin</p>
        <input ref={inputRef} type="password" maxLength={4} value={password} onChange={(e) => setPassword(e.target.value)} className="hidden-input" />
        <div className="pin-container">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className={`outer-circle ${i === password.length ? 'active' : ''}`}>
              <div className="inner-circle">{password.length > i && <div className="pin-dot" />}</div>
            </div>
          ))}
        </div>
        <button className={`login-button ${password.length === 4 ? 'enabled' : 'disabled'}`} onClick={handleSwitchUser} disabled={password.length !== 4}>
          Login
        </button>
        <button className="cancel-button" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default SwitchUserModal;
